/**
 * Collection
 */
import collectionFilters from '../lib/collection-filters';
import collectionPagination from '../lib/collection-pagination';
import collectionQuickview from '../lib/collection-quickview';
import collectionToolbar from '../lib/collection-toolbar';
import productItemApp from '../lib/product-item-app';
import comparePanel from '../lib/compare-panel';
import { shortlistAddTo } from '../lib/shortlist-add-to';
import collectionSortOptionsSort from '../lib/collection-sort-option-sort';
import uploadApp from '../lib/uploadApp';
import collectionHeroCategoryTabs from '../lib/collection-hero-category-tabs';
import pickupStoreFilterApp from '../lib/pickup-store-filter-app';
import quickShipFilterApp from '../lib/quick-ship-filter-app';

// Collection Products
productItemApp({
  dom: {
    parent: 'collection',
  },
});

// Collection Toolbar
collectionToolbar();

// Collection Pagination
collectionPagination();

// Collection Filters
collectionFilters();

// Collection Quickview
collectionQuickview();

// Compare Panel Accordion
comparePanel();

// Shortlist Buttons
shortlistAddTo();

// Collection Sort Options Sort
collectionSortOptionsSort();

// Collection Hero Category Tabs
collectionHeroCategoryTabs();

// Upload App
uploadApp();

// Pickup Store Filter App
pickupStoreFilterApp();

// Quick Ship Filter App
quickShipFilterApp();

// Collection Hero Tabs
const $collectionHeroTabs = document.querySelector('.tab');
if ($collectionHeroTabs) {
  const collectionHeroTabs = SDG.tabs({
    dom: {
      id: $collectionHeroTabs.id,
    },
  });
  collectionHeroTabs.init();
}
